import React from "react";
export default function AuthImage() {
  return <div className="flex items-center justify-center">
      <img alt="Grandpal caring community" className="max-w-[450px] w-full h-auto object-contain" src="/lovable-uploads/d8858b1e-c2d9-4ca2-a182-5bcdbc45a6f0.png" />
    </div>;
}